module.exports = __webpack_public_path__ + "img/airplanemode_active.190a5d1e.svg";